import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'approval-yes-icon',
  templateUrl: './approval-yes-icon.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApprovalYesIconComponent {}

